import { Link } from 'react-router-dom';
import { Building2, FolderOpen, Link2, Shield } from 'lucide-react';

const SheetsSectionTabs = ({
  activeTab = 'sheets',
  isAdmin = false
}) => (
  <nav className="flex shrink-0 flex-nowrap gap-1 rounded-[10px] border border-slate-200 bg-white p-1 shadow-sm" aria-label="Sheets sections">
    {[
      { id: 'sheets', label: 'Sheets', href: '/sheets', icon: Link2 },
      { id: 'workspaces', label: 'Workspaces', href: '/sheets/workspaces', icon: FolderOpen },
      { id: 'organizations', label: 'Organisations', href: '/sheets/organizations', icon: Building2 },
      ...(isAdmin ? [{ id: 'admin-access', label: 'Admin Access', href: '/sheets/admin-access', icon: Shield }] : [])
    ].map((tab) => {
      const Icon = tab.icon;
      const isActive = activeTab === tab.id;
      return (
        <Link
          key={tab.id}
          to={tab.href}
          title={tab.label}
          className={`inline-flex h-10 w-10 items-center justify-center gap-2 rounded-lg text-sm font-semibold transition-colors sm:w-auto sm:px-4 ${
            isActive
              ? 'bg-[#008080] text-white shadow-sm hover:bg-[#007171]'
              : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
          }`}
          aria-current={isActive ? 'page' : undefined}
        >
          <Icon className="h-4 w-4" />
          <span className="hidden sm:inline">{tab.label}</span>
        </Link>
      );
    })}
  </nav>
);

export default SheetsSectionTabs;
